<script lang="ts" setup>
import {toRef} from 'vue'
import {type CustomAction, useSnackbarStore} from '@/stores/SnackbarStore'

const {t} = useI18n()

// Define the properties that the component will receive
const props = defineProps({
  snackbarShow: Boolean,
  errorMsg: String,
  snackbarStatus: String,
  snackbarActions: {
    type: Array as () => CustomAction[], // Custom type to define snackbar actions
    default: () => []
  },
})

const snackbar = useSnackbarStore()
const snackbarRef = toRef(props, 'snackbarShow')

const closeSnackbar = () => {
  snackbar.closeSnackbar()
}
</script>

<template>
  <div class="text-center">
    <v-snackbar
        v-model="snackbarRef"
        :color="snackbarStatus"
        :vertical="snackbarActions.length ? true : undefined"
        timeout="-1"
    >

      {{ errorMsg }}

      <template v-slot:actions>
        <v-btn
            v-for="act of snackbarActions"
            :key="act.actionName"
            @click="act.onClick"
            size="small"
            class="me-1"
        >
          {{ act.actionName }}
        </v-btn>
        <v-btn size="small" @click="closeSnackbar">{{ t('buttons.close')}}</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>